import { useAtom } from 'jotai'
import { useEntityFiltersBar } from '@sequencehq/core-components'
import { useNavigate } from 'react-router-dom'
import {
  watchtowerFiltersAtom,
  WatchtowerFilterType
} from 'Automations/watchtower/atoms'
import { WatchtowerFilterButton } from 'Automations/components'
import { automationsPaths } from 'Automations/router'
import { useFeatureFlags } from 'hooks/useFeatureFlags'
import { ALL_TASKS_FILTER_CONFIGS } from '../allTasksFilterConfigs'

export const AddFilter = () => {
  const flags = useFeatureFlags()
  const filters = ALL_TASKS_FILTER_CONFIGS({
    useAutomationsDunning: flags.useAutomationsDunning
  })
  const [selectedFilters, setSelectedFilters] = useAtom(watchtowerFiltersAtom)
  const navigate = useNavigate()
  const {
    selectedFilters: hookFilters,
    hasActiveFilters,
    updateFilter: baseUpdateFilter
  } = useEntityFiltersBar<WatchtowerFilterType>({
    filters,
    selectedFilters,
    onFilterChange: setSelectedFilters
  })

  const updateFilter = (type: WatchtowerFilterType, values: string[]) => {
    baseUpdateFilter(type, values)
    // When status is selected from the "Needs Action" view, navigate to "All"
    if (type === 'status' && values.length > 0) {
      navigate(automationsPaths.executionInbox())
    }
  }

  return (
    <WatchtowerFilterButton
      filterConfigs={filters}
      selectedFilters={hookFilters}
      hasActiveFilters={hasActiveFilters}
      onFilterChange={updateFilter}
    />
  )
}
